/**
 * Parser for the TexturePacker Unity ".tpsheet" text format (:format=40300), reused directly from
 * the Unity client's atlases (profile/respack/cards). Each sprite line is:
 *   name;x;y;width;height; pivotX;pivotY; borderL;borderB;borderR;borderT; <physics...>
 * Coordinates are in TexturePacker/Unity space (bottom-left origin); the AtlasLoader flips Y for Pixi.
 */
export interface TpFrame {
  name: string;
  x: number;
  y: number;
  w: number;
  h: number;
  pivotX: number;
  pivotY: number;
}

export interface TpSheet {
  texture: string;
  width: number;
  height: number;
  frames: TpFrame[];
}

export function parseTpsheet(text: string): TpSheet {
  let texture = '';
  let width = 0;
  let height = 0;
  const frames: TpFrame[] = [];

  for (const raw of text.split(/\r?\n/)) {
    const line = raw.trim();
    if (line === '' || line.startsWith('#')) continue;

    if (line.startsWith(':')) {
      const eq = line.indexOf('=');
      if (eq < 0) continue;
      const key = line.slice(1, eq);
      const val = line.slice(eq + 1);
      if (key === 'texture') texture = val;
      else if (key === 'size') {
        const [w, h] = val.split('x');
        width = Number(w);
        height = Number(h);
      }
      continue;
    }

    const parts = line.split(';').map((s) => s.trim());
    if (parts.length < 5) continue;
    frames.push({
      name: parts[0],
      x: Number(parts[1]),
      y: Number(parts[2]),
      w: Number(parts[3]),
      h: Number(parts[4]),
      pivotX: parts.length > 5 ? Number(parts[5]) : 0.5,
      pivotY: parts.length > 6 ? Number(parts[6]) : 0.5,
    });
  }

  return { texture, width, height, frames };
}
